export const allowedClientSubdomains = ['star']

const allowedStandardDomains = ['go','localhost:3000']
const allAllowedSubDomains = [ ...allowedClientSubdomains, ...allowedStandardDomains ]

export const getClientSubdomain = () => {
  const originFull = window.origin;
  const splitVal = originFull.indexOf('https://') > -1 ? 'https://' : 'http://';
  const origin = originFull.split(splitVal)[1] || '';
 
  const parts = origin.split('.');
  const firstPart = parts[0];

  if (process.env.REACT_APP_SUBDOMAIN_ENV) {
    return process.env.REACT_APP_SUBDOMAIN_ENV
  }
  else if (allAllowedSubDomains.indexOf(firstPart) > -1) {
    return firstPart
  }
  else {
    return ''
  }
}

export const getEnv = () => {
  const host = window.location.host;

  // Always use qa if in a localhost environment
  if (host.indexOf('localhost') > -1) {
    return 'qa'
  } else {
    // detect env
    const parts = host.split('.');
    // Only qa/uat are real environments; any other segment before 'prosolve.com' means prod
    const envPart = parts[parts.length-3];
    const env = ['qa', 'uat'].includes(envPart) ? envPart : '';
    return env;
  }
}